import { render, staticRenderFns } from "./FormStepSuccess.vue?vue&type=template&id=70c4589f&scoped=true&"
import script from "./FormStepSuccess.vue?vue&type=script&lang=js&"
export * from "./FormStepSuccess.vue?vue&type=script&lang=js&"
import style0 from "./FormStepSuccess.vue?vue&type=style&index=0&id=70c4589f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../BougeMaVille-reborn-client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c4589f",
  null
  
)

export default component.exports